import gql from 'graphql-tag';

export const searchCoverageHours = gql`
  query searchCoverageHours($channelId: UUID!, $pagination: PaginationInput!) {
    searchCoverageHours(channelId: $channelId, pagination: $pagination) {
      coverageHours {
        routingId
        category
        issue
        blocks {
          id
          teamId
          teamName
          daysOfWeek
          startMinute
          endMinute
          timezone
        }
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
